import VerifyDocs from "./VerifyDocs";
export default VerifyDocs